import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  slideBarReducer, productsReducer, collectionsReducer,
  currentUserReducer, productsCollectionsReducer, productReducer, productVariationsReducer, productFormReducer
} from './reducers';

const rootReducer = combineReducers({
  slideBarReducer, productsReducer, productReducer, currentUserReducer, collectionsReducer,
  productsCollectionsReducer, productVariationsReducer, productFormReducer
});

export const store = configureStore({
  reducer: rootReducer,
});


export type AppStore = ReturnType<typeof configureStore>;
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = typeof store.dispatch;